(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('geostock-locations')) {
    class GeostockLocations extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.load();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      async load() {
        const shop = this.dataset.shopDomain;
        const variantId = this.dataset.variantId;
        if (!shop || !variantId) { this.render([]); return; }

        const url = 'https://api.geostock.app/shop/'
          + encodeURIComponent(shop)
          + '/variant_locations/'
          + encodeURIComponent(variantId)
          + '?lat=null&lon=null';

        let locations = [];
        try {
          const res = await fetch(url, { signal: this.controller.signal });
          if (res.ok) {
            const data = await res.json();
            locations = data.locations || [];
          }
        } catch (err) {
          if (err.name === 'AbortError') return;
          console.warn('GeoStock locations fetch failed:', err);
        }
        this.render(locations);
      }

      normalizeCity(value) {
        return String(value || '').trim().replace(/:$/, '').toLowerCase();
      }

      render(locations) {
        const requiredAttr = this.dataset.requiredCities || '';
        const requiredCities = requiredAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        const self = this;

        const feedByCity = {};
        locations.forEach(function (l) {
          const key = self.normalizeCity(l.city || l.name);
          if (key) feedByCity[key] = l;
        });

        const seen = {};
        const cells = [];

        requiredCities.forEach(function (name) {
          const key = self.normalizeCity(name);
          const match = feedByCity[key];
          const stock = (match && match.enabled) ? Number(match.stock) || 0 : 0;
          cells.push({ name: name, stock: stock });
          seen[key] = true;
        });

        locations.forEach(function (l) {
          if (!l.enabled) return;
          const rawName = (l.city || l.name || '').trim().replace(/:$/, '');
          const key = self.normalizeCity(rawName);
          if (!key || seen[key]) return;
          cells.push({ name: rawName, stock: Number(l.stock) || 0 });
          seen[key] = true;
        });

        if (cells.length === 0) { this.innerHTML = ''; return; }

        this.innerHTML = cells.map(function (c) {
          const display = c.stock > 20 ? '20+' : String(c.stock);
          const modifier = c.stock <= 0 ? 'inventory--low'
                         : c.stock <= 2 ? 'inventory--medium'
                         : 'inventory--high';
          return '<div class="inventory-locations__cell">'
            + '<span class="inventory ' + modifier + '">'
            + '<span class="inventory-locations__stores-name">' + self.escape(c.name) + '</span>'
            + '<span class="inventory-locations__stores-count">' + display + '</span>'
            + '</span>'
            + '</div>';
        }).join('');
      }

      escape(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
        });
      }
    }

    customElements.define('geostock-locations', GeostockLocations);
  }
  } catch(e) { console.error(e); }
})();

})();
